import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, Skeleton } from '@mui/material';

const SelectCustomerItemSkeleton = () => {
    return (jsxs(Wrapper, { children: [jsxs("div", { style: { display: "flex", justifyContent: "space-between" }, children: [jsx(Skeleton, { height: 14, width: "100px" }), jsx(Skeleton, { height: 14, width: "21px" })] }), jsx(Skeleton, { height: 14 })] }));
};
const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1.25, 2.5),
    borderBottom: `1px solid ${theme.palette.ui50}`,
    flexDirection: "column",
    "& > :first-child": {
        marginTop: theme.spacing(0.5),
    },
    "& > :last-child": {
        margin: theme.spacing(0.5, 0),
    },
}));

export { SelectCustomerItemSkeleton };
//# sourceMappingURL=SelectCustomerItemSkeleton.js.map
